import React, { useState, useEffect, useCallback } from 'react'
import useStyles from './style'
import { Grid, Breadcrumbs, Link, Typography } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import Testimonials from 'pages/home/testimonials'
import aboutUsApi from 'services/aboutUs'
import homeApi from 'services/home'
import { showLoader, hideLoader } from 'redux/loader/actions'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import { API_ENDPOINTS } from 'constants'
import CountMotion from 'sharedComponents/countMotion'

const list = [
  {
    id: 1,
    label: `YEARS OF FOUNDATION`,
    count: 50,
  },
  {
    id: 2,
    label: 'SKILLED TEAM MEMBERS',
    count: 15,
  },
  {
    id: 3,
    label: `HAPPY CUSTOMERS`,
    count: 599,
  },
  {
    id: 4,
    label: 'MONTHLY ORDERS',
    count: 73,
  },
]

const About = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [aboutUsDetails, setAboutUsDetails] = useState([])
  const [testimonials, setTestimonials] = useState([])

  // Get about us details api
  const getAboutUsDetails = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        res?.data?.data?.results?.[0] &&
          setAboutUsDetails(res?.data?.data?.results?.[0])
      } else {
        setAboutUsDetails([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get about us details Api', err)
    }
    aboutUsApi.getAboutUsDetails().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getAboutUsDetails()
  }, [getAboutUsDetails])

  // GET TESTIMONIALS
  const getTestimonials = useCallback(() => {
    dispatch(showLoader('Loading please wait...'))
    const onSuccess = (res) => {
      dispatch(hideLoader())
      if (res?.data?.status?.toLowerCase() === 'true') {
        setTestimonials(res?.data?.data?.results)
      } else {
        setTestimonials([])
      }
    }
    const onFailure = (err) => {
      dispatch(hideLoader())
      console.log('Get Shop by category details Api', err)
    }
    homeApi.getTestimonial().then(onSuccess, onFailure)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    getTestimonials()
  }, [getTestimonials])

  return (
    <>
      <Grid container className={classes.root}>
        {/* Breadcrumbs */}
        <Grid item xs={12} className={classes.breadcrumbs}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Link underline="hover" color="inherit" href="/">
              Home
            </Link>
            <Typography variant="body1">About us</Typography>
          </Breadcrumbs>
        </Grid>
        {/* Story */}
        {!_.isEmpty(aboutUsDetails) ? (
          <Grid item xs={12} className={classes.storyWrapper}>
            <div className={classes.storeImgContainer}>
              <img
                src={API_ENDPOINTS.FILE_URL + aboutUsDetails?.image}
                alt="storeImg"
                className={classes.storeImg}
              />
            </div>
            <section className={classes.storyContent}>
              <div className={classes.title}>
                <Typography variant="h3">
                  {aboutUsDetails?.title || ''}
                </Typography>
              </div>
              <div className={classes.description}>
                <Typography variant="body1">
                  {aboutUsDetails?.content || ''}
                </Typography>
              </div>
            </section>
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
      {/* counts */}
      {!_.isEmpty(aboutUsDetails) ? (
        <Grid container>
          <Grid item xs={12} className={classes.countsWrapper}>
            <Grid xs={12} sm={6} md={3}>
              <div className={classes.countTitle}>
                <Typography variant="h5">
                  YEARS OF <br />
                  FOUNDATION
                </Typography>
              </div>
              <div className={classes.count}>
                <Typography variant="h4">
                  <CountMotion
                    number={aboutUsDetails?.foundation || 0}
                    duration={5}
                  />
                </Typography>
              </div>
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <div className={classes.countTitle}>
                <Typography variant="h5">
                  SKILLED TEAM <br />
                  MEMBERS
                </Typography>
              </div>
              <div className={classes.count}>
                <Typography variant="h4">
                  <CountMotion
                    number={aboutUsDetails?.members || 0}
                    duration={5}
                  />
                </Typography>
              </div>
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <div className={classes.countTitle}>
                <Typography variant="h5">
                  HAPPY <br />
                  CUSTOMERS
                </Typography>
              </div>
              <div className={classes.count}>
                <Typography variant="h4">
                  <CountMotion
                    number={aboutUsDetails?.customers || 0}
                    duration={5}
                  />
                </Typography>
              </div>
            </Grid>
            <Grid xs={12} sm={6} md={3}>
              <div className={classes.countTitle}>
                <Typography variant="h5">
                  MONTHLY <br />
                  ORDERS
                </Typography>
              </div>
              <div className={classes.count}>
                <Typography variant="h4">
                  <CountMotion
                    number={aboutUsDetails?.orders || 0}
                    duration={5}
                  />
                </Typography>
              </div>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
      {/* Testimonials */}
      <Testimonials testimonials={testimonials} />
    </>
  )
}

export default About
